//CHECKBOX

let checkboxRegistration = document.querySelectorAll(".form__checkbox");

checkboxRegistration.forEach((el) => {
  if (el.querySelector("input").checked) {
    el.classList.add("active");
  }
  el.addEventListener("click", function (e) {
    if (this.classList.contains("active")) {
      this.querySelector("input").checked = false;
    } else {
      this.querySelector("input").checked = true;
    }
    this.classList.toggle("active");
  });
});

// for Google Analytics
// document.getElementById("signup_google") &&
// document.getElementById("signup_google").addEventListener("click", function () {
//     event.preventDefault();
//     dataLayer.push({'event': 'sing_up', 'method': 'google'});
//     window.location.href = "/auth?authclient=google";
// });
//
// document.getElementById("signup_facebook") &&
// document.getElementById("signup_facebook").addEventListener("click", function () {
//     dataLayer.push({'event': 'sing_up', 'method': 'facebook'});
// });
// for Google Analytics END

// CREATE ACCOUNT
function getRegistrationType() {
    return document.querySelector(".registration-form").getAttribute("data-registration-by-social-network");
};

let buttonCreateAccount = document.getElementById("btn_create_account");
buttonCreateAccount &&
  document
    .getElementById("btn_create_account")
    .addEventListener("click", function () {
        // for Google Analytics
        //alert('test5');

        //dataLayer.push({'event': 'sing_up5', 'method': 'email'});
        // for Google Analytics END
      
      // for check registration type
      const regBySocialNetwork = getRegistrationType();

      let inputName = document.getElementById("registration_name");
      let inputEmail = document.getElementById("registration_email");

      let inputPass = document.getElementById("registration_pass");
      let inputPassConfirm = document.getElementById(
        "registration_confirm_pass"
      );
      let inputOS = document.getElementById("registration_OS");
      let inputCountry = document.getElementById("registration_country");
      let inputIndustry = document.getElementById("registration_industry");
      let checkboxReceiveNews = document.getElementById(
        "registration_receive_news"
      );
      let checkboxPrivacyPolicy = document.getElementById(
        "registration_privacy_policy"
      );
      let recaptcha = document.getElementById(
          "g-recaptcha-response"
      );

      let inputNameMsg = document.getElementById("registration_name_error");
      let inputEmailMsg = document.getElementById("registration_email_error");
      let inputPassMsg = document.getElementById("registration_pass_error");
      let inputPassConfirmMsg = document.getElementById(
        "registration_confirm_pass_error"
      );
      let checkboxPrivacyPolicyMsg = document.getElementById(
        "registration_privacy_policy_error"
      );

      if (!validateOnEmpty(inputName)) {
        inputNameMsg.classList.add("show_msg");
      } else {
        inputNameMsg.classList.remove("show_msg");
      }
      if (!validateEmail(inputEmail)) {
        inputEmailMsg.classList.add("show_msg");
      } else {
        inputEmailMsg.classList.remove("show_msg");
      }
      if(regBySocialNetwork == "false") {
        if (!validateOnEmpty(inputPass)) {
          inputPassMsg.classList.add("show_msg");
        } else {
          inputPassMsg.classList.remove("show_msg");
        }
        if (!validateOnEmpty(inputPassConfirm)) {
          inputPassConfirmMsg.innerText = "Please enter confirm password!";
          inputPassConfirmMsg.classList.add("show_msg");
          return;
        } else {
          inputPassConfirmMsg.classList.remove("show_msg");
        }
        if (inputPass.value !== inputPassConfirm.value) {
          inputPassConfirmMsg.innerText =
            "Confirmed password does not match password!";
          inputPassConfirmMsg.classList.add("show_msg");
        } else {
          inputPassConfirmMsg.classList.remove("show_msg");
        }
      }
      if (!getChecboxActive(checkboxPrivacyPolicy)) {
        checkboxPrivacyPolicyMsg.classList.add("show_msg");
        return;
      } else {
        checkboxPrivacyPolicyMsg.classList.remove("show_msg");
      }

        // for Google Analytics test
        //dataLayer.push({'event': 'sing_up_before_create', 'method': 'email'});
        // for Google Analytics END




        if(regBySocialNetwork == "false") {
            createAccountRequest(
                inputName.value,
                inputEmail.value,
                inputPass.value,
                inputPassConfirm.value,
                inputOS.getAttribute("data-id"),
                inputCountry.getAttribute("data-id"),
                inputIndustry.getAttribute("data-id"),
                getChecboxActive(checkboxReceiveNews),
                getChecboxActive(checkboxPrivacyPolicy),
                regBySocialNetwork,
                recaptcha.value,
            );
        } else {
            createAccountRequest(
                inputName.value,
                inputEmail.value,
                "",
                "",
                inputOS.getAttribute("data-id"),
                inputCountry.getAttribute("data-id"),
                inputIndustry.getAttribute("data-id"),
                getChecboxActive(checkboxReceiveNews),
                getChecboxActive(checkboxPrivacyPolicy),
                regBySocialNetwork,
                recaptcha.value,
            );
        }



    });
function createAccountRequest(
  name,
  email,
  pass,
  passConfirm,
  os,
  country,
  industry,
  receiveNews,
  privacyPolicy,
  regSocialNetwork,
  recaptcha,
) {

  const request = new XMLHttpRequest();
  const url = document
    .querySelector("#registration_url")
    .getAttribute("data-registration");
  const params =
    "RegisterForm[full_name]=" +
    name +
    "&RegisterForm[email]=" +
    email +
    "&RegisterForm[password]=" +
    pass +
    "&RegisterForm[password_confirmation]=" +
    passConfirm +
    "&RegisterForm[country]=" +
    country +
    "&RegisterForm[primary_OS]=" +
    os +
    "&RegisterForm[following_industry]=" +
    industry +
    "&RegisterForm[terms_and_conditions]=" +
    privacyPolicy +
    "&RegisterForm[news_subscription]=" +
    receiveNews +
    "&RegisterForm[reg_social_network]=" +
    regSocialNetwork +
    "&RegisterForm[recaptcha]=" +
    recaptcha +
    "&_csrf=" +
    jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
      //  console.log("request response", request.responseText);
        let response = JSON.parse(request.responseText);
        window.scrollTo({ top: 0, behavior: "smooth" });
        if (response.status === "ok") {
            // for Google Analytics

            var method = 'none';
            if(regSocialNetwork == "false") {
                method = "email";
            }else {
                method = "google/facebook"
            }

            var referrer = document.referrer;
            var signup_product = 'sign_up';
            if(referrer.includes('3dcoatprint')){
                signup_product = 'sign_up_print';
            }

            setTimeout(function() {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event' : 'sing_up',
                    'method': method,
                    'signup_product': signup_product,
                    'user_id': response.userID,
                    'eventCallback' : function() {
                        window.location.href = response.message;
                    },
                    'eventTimeout' : 2000
                });
            }, 100);

            window.location.href = response.message;
            //for Google Analytics END

        }
        if (response.status === "error") {
          let responseErrorsMsg = createErrorsMsg(response.errors);
          if (typeof TrackJS !== "undefined") {
              var messageError = 'ERROR event: sing_up, email: ' + email + ', responseErrorsMsg: ' + responseErrorsMsg;
              console.log('TrackJS: ' + messageError);
              TrackJS.track(messageError);
          }
          showMsg("msg_error_registration", responseErrorsMsg);
        }
      } else {
        window.location.href = "/404";
      }
    } 
  });
  request.send(params);
}
// END CREATE ACCOUNT



function getGoogleClientID(){
    try {
        var tracker = ga.getAll()[0];
        var clientId = tracker.get('clientId');
        return clientId;
    } catch (error) {
        return error;
    }
}

function getGoogleClientIDInCycle(i, callback){
    const maxNumberOfCycle = 100;
    const timeoutOfCycle = 100;

    var clientId = false;
    window.setTimeout(() => {
        clientId = getGoogleClientID();
        console.log(i + ' ' + clientId);
        if(typeof clientId != 'string') {
            i++;
            if(i < maxNumberOfCycle){
                getGoogleClientIDInCycle(i, callback);
            }else{
                callback(clientId, i);
            }
        } else{
            callback(clientId, i);
        }
    }, timeoutOfCycle);
}




function sendTrackJSMessage(message){
    try {
        console.log('TrackJS: ' + message);
        TrackJS.track(message);
    } catch (error) {
        console.log('TrackJS ERROR: ' + error);
    }
}

// OPEN WINDOW FOR SIGN IN/SIGN UP BY GOOGLE/FACEBOOK
document.querySelector("#signin_google") && document.querySelector("#signin_google").addEventListener("click", openHrefInNewWindow, false);
document.querySelector("#signin_facebook") && document.querySelector("#signin_facebook").addEventListener("click", openHrefInNewWindow, false);

document.querySelector("#signup_google") && document.querySelector("#signup_google").addEventListener("click", openHrefInNewWindow, false);
document.querySelector("#signup_facebook") && document.querySelector("#signup_facebook").addEventListener("click", openHrefInNewWindow, false);

let openedWindow;
let openedWindowTimer;

function openHrefInNewWindow (event) {
  event.preventDefault();
  if(checkMobDevice()) {
    openedWindow = window.open(this.href, '_blank', 'width=0,height=0');
  } else {
    openedWindow = window.open(this.href, '_blank', 'width=600,height=600');
  }
  openedWindowTimer = setInterval(() => checkFinishLoginBySocialNet(), 1000);
};


function checkFinishLoginBySocialNet() {
  let localStorageData = localStorage.getItem('pilgway-finish-login-by-social-network');

  if(localStorageData == "true") {
    // stop timer
    clearInterval(openedWindowTimer);
    
    localStorage.setItem('pilgway-finish-login-by-social-network', false);
    // close opened window
    openedWindow.close();

    let urlRedirect = localStorage.getItem('pilgway-social-redirect');
    console.log('get from localStorage pilgway-social-redirect:', urlRedirect);

    //alert(socialRedirect);
    window.location.href = urlRedirect;
    // setTimeout(function() {
    //     window.location.href = urlRedirect;
    // }, 3000);  // Optional delay of 1 second before redirection
  }
}

if(finisedLoginByNetwork) {
  localStorage.setItem('pilgway-finish-login-by-social-network', true);
  localStorage.setItem('pilgway-social-redirect', socialRedirect);
  console.log('set localStorage pilgway-social-redirect:', socialRedirect);
  finisedLoginByNetwork = false;
  //alert(socialRedirect);
}
